import { render, staticRenderFns } from "./AssetInfo.vue?vue&type=template&id=7baf09d4&"
import script from "./AssetInfo.vue?vue&type=script&lang=js&"
export * from "./AssetInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports